import { render, staticRenderFns } from "./NoticiasAdmin.vue?vue&type=template&id=223d1712&scoped=true&"
import script from "./NoticiasAdmin.vue?vue&type=script&lang=js&"
export * from "./NoticiasAdmin.vue?vue&type=script&lang=js&"
import style0 from "./NoticiasAdmin.vue?vue&type=style&index=0&id=223d1712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223d1712",
  null
  
)

export default component.exports